import {EvaluationCriteriaWithScores} from '@frontend/shared-api';
import {
  CountryCoverageBand,
  RfpParticipatingTool,
  SuitabilityMode,
  SuitabilityThresholds,
} from './rfp-invitation.types';

const HIGH_COUNTRY_COVERAGE = 90;
const MEDIUM_COUNTRY_COVERAGE = 75;

export function dataCompleteness(
  criteria: EvaluationCriteriaWithScores[],
  hrToolDirectusId: string,
): number {
  const attributes = criteria
    .flatMap((criterion) => criterion.subCriteria)
    .flatMap((subCriterion) => subCriterion.attributes);
  const answered = attributes.filter((attribute) =>
    attribute.scores.some(
      (score) => score.hrToolDirectusId === hrToolDirectusId && !score.scoreAbsent,
    ),
  ).length;

  return attributes.length === 0 ? 0 : Math.round((answered / attributes.length) * 100);
}

export function coverageFor(tool: RfpParticipatingTool, mode: SuitabilityMode): number {
  const suitability = tool.suitability;
  if (!suitability) {
    return 0;
  }
  return mode === 'combined' ? suitability.combinedCoverage : suitability.functionCoverage;
}

export function isPreferred(
  tool: RfpParticipatingTool,
  mode: SuitabilityMode,
  thresholds: SuitabilityThresholds,
): boolean {
  return (
    coverageFor(tool, mode) >= thresholds.coverage && (tool.rfiPercentage ?? 0) >= thresholds.rfi
  );
}

export function countryCoverageBand(countryCoverage: number): CountryCoverageBand {
  if (countryCoverage >= HIGH_COUNTRY_COVERAGE) {
    return 'high';
  }
  return countryCoverage >= MEDIUM_COUNTRY_COVERAGE ? 'medium' : 'low';
}
